// 歷屆賽事回顧配置（PC/H5 可共用）

const eventReviewList = [
  {
    id: 10,
    year: "2026",
    date: "6-6",
    list: [
      {
        title: "2026年越南首屆「中文路大賽」中文詩文朗誦比賽總決賽圓滿舉行！",
        resultUrl: "/eventReview_2026_vn",
        image:
          "https://chineserd-website-1256597606.cos.ap-hongkong.myqcloud.com/official/news/articles/20260608-01/1780902848685-3bacd2e5-8a98-4629-92b8-ff1c8e51383e.jpg",
        media: [
          {
            name: "人民网-国际频道",
            url: "http://world.people.com.cn/n1/2026/0608/c1002-40735899.html",
          },
          {
            name: "ULIS",
            url: "https://ulis.vnu.edu.vn/vong-chung-ket-cuoc-thi-con-duong-hoa-ngu-2026/",
          },
          {
            name: "Nhân dân",
            url: "https://nhandan.vn/hai-thi-sinh-tu-thu-do-vo-dich-cuoc-thi-con-duong-hoa-ngu-nam-2026-post967388.html",
          },
          {
            name: "Báo Tiền Phong",
            url: "https://tienphong.vn/nu-sinh-ngoai-thuong-gianh-giai-nhat-cuoc-thi-con-duong-hoa-ngu-post1849389.tpo",
          },
          {
            name: "Thông tấn xã (báo hình)",
            url: "https://vietnammedia.vnanet.vn/video/suc-hut-cua-tieng-trung-doi-voi-gioi-tre-190312.htm",
          },
          {
            name: "Thông tấn xã",
            url: "https://web.facebook.com/share/v/1BPd7j3NuS/?mibextid=wwXIfr&_rdc=1&_rdr",
          },
          {
            name: "Khoa Trung - ULIS",
            url: "https://www.facebook.com/share/1Ct2PWhneP/?mibextid=wwXIfr",
          },
          {
            name: "越通社",
            url: "https://www.facebook.com/share/v/1CYCEeATLx/?mibextid=wwXIfr",
          },
        ],
      },
    ],
  },
  {
    id: 9,
    year: "2026",
    date: "4-25",
    list: [
      {
        title: "2026年第五屆「曾憲備•紫荊盃」朗誦比賽圓滿落幕",
        resultUrl: "https://speech.chineserd.com/eventReview_2026",
        image: require("@/assets/image/eventReviewImage/2026.jpg"),
        media: [],
      },
    ],
  },
  {
    id: 8,
    year: "2026",
    date: "4-18",
    list: [
      {
        title: "2026年印尼第二屆「中文通」詩歌朗誦與演講比賽圓滿落幕",
        resultUrl: "https://www.chineserd.com.hk/web_id2026/",
        image: require("@/assets/image/eventReviewImage/2026-id.webp"),
        media: [],
      },
    ],
  },
  {
    id: 7,
    year: "2025",
    date: "8-10",
    list: [
      {
        title: "泰國「中文路杯」中文朗誦比賽圓滿落幕",
        resultUrl: "https://www.chineserd.com.hk/web_thailand2025/",
        image: require("@/assets/image/eventReviewImage/2025-th.jpg"),
        media: [
          {
            name: "人民网-国际频道",
            url: "http://world.people.com.cn/n1/2025/0811/c1002-40540190.html",
          },
          {
            name: "中国新闻网",
            url: "https://m.chinanews.com/wap/detail/chs/zw/10462681.shtml",
          },
          {
            name: "中央广播电视总台Nihao-Sawadee泰语FB",
            url: "https://www.facebook.com/share/v/1EiTDvb71T/",
          },
          {
            name: "ผชช.สุมิตรา ร่วมพิธีมอบรางวัลการแข่งขันการอ่านบทประพันธ์จีนชิงถ้วยรางวัล“Chinese Road” รอบชิงชนะเลิศ",
            url: "https://opec.go.th/gallery/detail/916",
          },
          // {
          //   name: "https://www.facebook.com/",
          //   url: "https://www.facebook.com/share/p/173uCuX97U/?mibextid=wwXIfr",
          // },
          // {
          //   name: "https://x.com/",
          //   url: "https://x.com/opec_pr/status/1955200045919375579?s=46&t=1lEiOuqlnjr9ECYfxBeNPg",
          // },
          // {
          //   name: "https://www.instagram.com/",
          //   url: "https://www.instagram.com/p/DNQArcASkIX/?igsh=ZTh6N2Ztejdoa2xt",
          // },
        ],
      },
    ],
  },
  {
    id: 6,
    year: "2025",
    date: "7-5",
    list: [
      {
        title: "2025年第四屆「曾憲備•紫荊盃」朗誦比賽圓滿落幕",
        // resultUrl: "https://speech.zhixin2018.cn/eventReview_2025",
        resultUrl: "https://speech.chineserd.com/eventReview_2025",
        image: require("@/assets/image/eventReviewImage/2025.jpg"),
        media: [
          // {
          //   name: "大公網",
          //   url: "https://www.takungpao.com/special/239159/2025/0707/1101796.html",
          // },
          {
            name: "巴士的報",
            url: "https://www.bastillepost.com/hongkong/article/15067178",
          },
          {
            name: "香港經濟新聞網",
            url: "http://www.gzdushiw.cn/xwzx/2255.html",
          },
          {
            name: "CAPITAL",
            url: "https://www.capital-hk.com/topics/news_02_06072025",
          },
          {
            name: "DAB Official Site",
            url: "https://www.dab.org.hk/post/%E7%AC%AC%E5%9B%9B%E5%B1%86%E3%80%8C%E6%9B%BE%E6%86%B2%E5%82%99-%E7%B4%AB%E8%8D%8A%E7%9B%83%E3%80%8D%E5%85%A8%E6%B8%AF%E5%B0%91%E5%85%92%E6%99%AE%E9%80%9A%E8%A9%B1%E6%9C%97%E8%AA%A6%E6%AF%94%E8%B3%BD%EF%BC%88%E5%80%8B%E4%BA%BA%E8%B3%BD%E5%8F%8A%E5%9C%98%E9%AB%94%E8%B3%BD%EF%BC%89%E5%9C%93%E6%BB%BF%E8%88%89%E8%A1%8C-%E5%86%80%E6%8F%90%E5%8D%87%E5%AD%B8%E7%94%9F%E6%84%9B%E5%9C%8B%E6%83%85%E6%84%9F",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    year: "2025",
    date: "4-26",
    list: [
      {
        title: "印尼「中文通」普通話詩歌朗誦比賽圓滿落幕",
        resultUrl: "https://www.chineserd.com.hk/web_indonesia2025/",
        image: require("@/assets/image/eventReviewImage/2025-id.jpg"),
        media: [
          {
            name: "Kompas",
            url: "https://www.kompas.com/edu/read/2025/04/30/101413671/diklaim-ada-1800-peserta-kompetisi-puisi-mandarin-berbasis-ai-selesai",
          },
          {
            name: "Rcti+",
            url: "https://www.rctiplus.com/news/detail/gaya-hidup/4742800/cara-pelajarmanfaatkan-teknologi-ai-untuk-bahasa-mandarin",
          },
          {
            name: "Metrotvnews",
            url: "https://www.metrotvnews.com/read/b1oCV9rl-kompetisi-puisi-mandarin-jembatan-penting-pertukaran-budaya-tiongkok-dan-indonesia",
          },
          {
            name: "Medcom",
            url: "https://www.medcom.id/pendidikan/news-pendidikan/zNARWYnb-mandarin-champion-2025-ini-daftar-pemenang-kompetisi-puisi-mandarin-berbasis-ai",
          },
          {
            name: "Infobank",
            url: "https://infobanknews.com/mandarin-champion-2025-tingkatkan-kualitas-sdm-agar-bisa-bersaing-secara-global/",
          },
          {
            name: "Okezone",
            url: "https://edukasi.okezone.com/read/2025/04/29/65/3134887/cara-pelajar-manfaatkan-teknologi-ai-untuk-bahasa-mandarin",
          },
          {
            name: "Warta Ekonomi",
            url: "https://wartaekonomi.co.id/read565321/mandarin-champion-2025-kompetisi-puisi-mandarin-berbasis-ai-sukses-digelar",
          },
          {
            name: "Investor Daily",
            url: "https://drive.google.com/file/d/1DC2Kfyer-EkYZty4YJK4uKvdKv7JJEuh/view?usp=drive_link",
          },
          {
            name: "MNC Trijaya",
            url: "https://www.mnctrijaya.com/news/detail/71613/mandarin-champion-2025-kompetisi-membaca-puisi-berbahasa-mandarin-sukses-digelar",
          },
          {
            name: "Media Indonesia",
            url: "https://mediaindonesia.com/humaniora/766046/kompetisi-baca-puisi-bahasa-mandarin-perkuat-kualitas-sdm",
          },
          {
            name: "Industry",
            url: "https://www.industry.co.id/read/141582/kompetisi-puisi-berbahasa-mandarin-berbasis-ai-mandarin-champion-2025-sukses-digelar",
          },
          {
            name: "Media Indonesia",
            url: "https://mediaindonesia.com/galleries/detail_galleries/42254-grand-final-lomba-membaca-puisi-berbahasa-mandarin-2025#goog_rewarded",
          },
          {
            name: "Tribunnews",
            url: "https://m.tribunnews.com/images/editorial/view/2018400/kompetisi-puisi-mandarin-berbasis-ai",
          },
          {
            name: "Warta Ekonomi",
            url: "https://wartaekonomi.co.id/gallery-8790/mandarin-champion-2025",
          },
          {
            name: "InvestorTrust",
            url: "https://investortrust.id/business/64422/gandeng-kampus-chineserd-tingkatkan-kemampuan-sdm-indonesia-berbahasa-mandarin",
          },
          {
            name: "",
            url: "",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    year: "2024",
    date: "11-2",
    list: [
      {
        title: "2024年第三屆「曾憲備•紫荊盃」朗誦比賽（團體賽）回顧",
        resultUrl: "https://www.chineserd.com.hk/web_three_team/",
        image: require("@/assets/image/eventReviewImage/2024_team.webp"),
        media: [
          {
            name: "香港文匯網",
            url: "https://www.wenweipo.com/a/202411/02/AP67260e92e4b01d0e217639d1.html",
          },
          {
            name: "香港商報网",
            url: "https://www.hkcd.com.hk/content_app/2024-11/02/content_8665177.html",
          },
          {
            name: "巴士的報",
            url: "https://www.bastillepost.com/hongkong/article/14465377",
          },
          // {
          //   name: "大公網",
          //   url: "https://www.takungpao.com/special/239159/2024/1102/1027107.html",
          // },
          // {
          //   name: "中国教育网",
          //   url: "http://www.chinaedunet.com/huodong/xyss/2024/11/content_250291.shtml",
          // },
        ],
      },
    ],
  },
  {
    id: 3,
    year: "2024",
    date: "6-29",
    list: [
      {
        title: "2024年第三屆「曾憲備•紫荊盃」朗誦比賽（個人賽）回顧",
        resultUrl: "https://www.chineserd.com.hk/web_three_individual",
        image: require("@/assets/image/eventReviewImage/2024_individual.webp"),
        media: [
          {
            name: "香港文匯網",
            url: "https://www.wenweipo.com/a/202406/30/AP668069d3e4b0207a85f081b9.html",
          },
          {
            name: "香港商報网",
            url: "https://www.hkcd.com.hk/content_app/2024-06/29/content_8644925.html",
          },
          {
            name: "香港商報网",
            url: "https://www.hkcd.com.hk/content_app/2024-06/29/content_8644922.html",
          },
          {
            name: "巴士的報",
            url: "https://www.bastillepost.com/hongkong/article/14158854",
          },
          // {
          //   name: "大公網",
          //   url: "https://www.takungpao.com/special/239159/2024/0630/986377.html",
          // },
        ],
      },
    ],
  },
  {
    id: 2,
    year: "2023",
    date: "10-28",
    list: [
      {
        title: "2023年第二屆「曾憲備•紫荊盃」朗誦比賽回顧",
        resultUrl: "https://www.chineserd.com.hk/web_two",
        image: require("@/assets/image/eventReviewImage/2023.jpg"),
        media: [
          {
            name: "香港商報",
            url: "http://www.hkcd.com/content_app/2023-10/29/content_8606966.html",
          },
          {
            name: "巴士的報",
            url: "https://www.bastillepost.com/hongkong/article/13534041-%E3%80%8C%E6%9B%BE%E6%86%B2%E5%82%99%C2%B7%E7%B4%AB%E8%8D%8A%E7%9B%83%E3%80%8D%E6%99%AE%E9%80%9A%E8%A9%B1%E6%9C%97%E8%AA%A6%E6%AF%94%E8%B3%BD%E5%AE%8C%E6%BB%BF%E7%B5%90%E6%9D%9F-%E6%9D%8E%E6%85%A7",
          },
          {
            name: "明報",
            url: "https://news.mingpao.com/pns/%E6%B8%AF%E8%81%9E/article/20231030/s00002/1698596901937/%E3%80%90emily%E3%80%91%E6%99%AE%E9%80%9A%E8%A9%B1%E6%9C%97%E8%AA%A6%E8%B3%BD%E7%94%A8ai%E5%88%86%E6%9E%90%E6%BA%96%E7%A2%BA%E5%BA%A6",
          },
          {
            name: "凤凰网",
            url: "https://finance.ifeng.com/c/8UItPZwbnUn",
          },
          {
            name: "腾讯新闻",
            url: "https://page.om.qq.com/page/OBEVKwquoqPzPAAsPjQN9ooA0",
          },
          {
            name: "百度",
            url: "https://baijiahao.baidu.com/s?id=1781141979794085451",
          },
          // {
          //   name: "中国教育网",
          //   url: "http://www.chinaedunet.com/huodong/zxhd/2023/10/content_248561.shtml",
          // },
          {
            name: "中国教育信息化",
            url: "https://www.ict-edu.cn/html/yingyong/2023/qiyedongtai_1030/9081.shtml",
          },
          {
            name: "中国教育信息服务网",
            url: "https://www.e-chinaedu.cn/html/jishuanli/2023/10-30/c_117827.shtml",
          },
          // {
          //   name: "太平洋教育网",
          //   url: "https://edu.pcbaby.com.cn/606/6067728.html",
          // },
          {
            name: "中国教育品牌网",
            url: "http://www.zgddmx.com/html/89251.html",
          },
          {
            name: "中国教育发展网",
            url: "http://www.zgjyfz.com.cn/jy/20231030201.html",
          },
          {
            name: "慧聪网教育",
            url: "http://edu.hczyw.com/2023/1030/71337.html",
          },
          {
            name: "青橘网",
            url: "http://www.qingjuwang.com.cn/zx/31703.html",
          },
          {
            name: "21世纪教育网（官方）",
            url: "http://news.21cnjy.com/A/1368601.shtml",
          },
          {
            name: "中国校园网",
            url: "http://www.jyfx.com.cn/jy/20231030200.html",
          },
          // {
          //   name: "用考网",
          //   url: "http://news.yongkao.com/jiaodian/202310/202310_23858.html",
          // },
          // {
          //   name: "教育视窗",
          //   url: "http://www.lipuedu.cn/hangye/2023/1030/12637.html",
          // },
          {
            name: "读创",
            url: "https://appdetail.netwin.cn/web/2023/10/3e46fc710f55cae7823267eb6466b617.html",
          },
          // {
          //   name: "知乎",
          //   url: "https://zhuanlan.zhihu.com/p/664026974",
          // },
        ],
      },
    ],
  },
  {
    id: 1,
    year: "2022",
    date: "12-3",
    list: [
      {
        title: "2022年首屆「粵海•紫荊盃」朗誦比賽回顧",
        resultUrl: "https://www.chineserd.com.hk/web",
        image: require("@/assets/image/eventReviewImage/2022.png"),
        media: [
          {
            name: "文匯報",
            url: "https://www.wenweipo.com/a/202212/07/AP639048d0e4b0e80f8118e7fe.html",
          },
          {
            name: "巴士的報",
            url: "https://www.bastillepost.com/hongkong/article/11838503-%e3%80%8c%e7%b2%b5%e6%b5%b7%c2%b7%e7%b4%ab%e8%8d%8a%e6%9d%af%e3%80%8d%e6%9c%97%e8%aa%a6%e6%af%94%e8%b3%bd%e6%88%90%e5%8a%9f%e8%88%89%e8%be%a6-%e5%90%b8%e5%bc%95%e9%80%be3000%e5%ad%b8%e7%94%9f%e5%8f%83?current_cat=3",
          },
          {
            name: "人民日報（香港）",
            url: "https://www.facebook.com/104936044581591/posts/pfbid02Lm18WRfEraF9wNGqPqL7wyGG6BRNfSMKPypcvaMyTBts412J1Xf5D7zg9H6k48fPl/?mibextid=cr9u03",
          },
          {
            name: "點新聞",
            url: "https://m.dotdotnews.com/s/202212/07/AP63903d86e4b0adad9d6eb397.html",
          },
          // {
          //   name: "香港經濟日報",
          //   url: "https://inews.hket.com/article/3422340?r=cpstni",
          // },
          // {
          //   name: "大公網",
          //   url: "http://www.takungpao.com/news/232109/2022/1209/795946.html",
          // },
        ],
      },
    ],
  },
];

export default eventReviewList;
